import { sql } from "drizzle-orm";
import { pgTable, text, timestamp, check } from "drizzle-orm/pg-core";

/**
 * Review verdicts for the superadmin Test Coverage tool (/superadmin/test-coverage):
 * does a requirement's test correctly assess it? Keyed by requirement id
 * ("DEV-327", "REQ-PLAN-001"). Created by migrations/0145_test_coverage_reviews.sql.
 */
export const testCoverageReviews = pgTable(
  "test_coverage_reviews",
  {
    requirementId: text("requirement_id").primaryKey(),
    verdict: text("verdict").notNull(), // 'approved' | 'needs_work'
    notes: text("notes"),
    reviewedBy: text("reviewed_by").notNull(),
    reviewedAt: timestamp("reviewed_at").notNull().defaultNow(),
  },
  (table) => ({
    verdictCheck: check("test_coverage_reviews_verdict_check", sql`${table.verdict} IN ('approved', 'needs_work')`),
  }),
);

export type TestCoverageReview = typeof testCoverageReviews.$inferSelect;
